export default function PrestigeVillageCredit() {
  return (
    <div className={"flex items-center gap-3 lg:gap-4 w-full py-4 border-y border-solid border-black/8 font-jost"}>
      <a
        href="https://prestigeandvillage.co.uk/"
        target="_blank"
        rel="noopener noreferrer"
        className="shrink-0 size-12 lg:size-16 overflow-clip"
        aria-label="Prestige and Village Limited">
        <img
          src="/assets/images/house-competition/prestige-village-logo.webp"
          alt="Prestige and Village"
          width={64}
          height={64}
          className="size-full object-contain"
        />
      </a>
      <div className="min-w-0 flex-1 text-sm lg:text-base font-normal leading-5 lg:leading-5.5 text-gray-1 break-words">
        Property transaction managed by Prestige and Village Limited
      </div>
    </div>
  );
}
